/**
 * Utilitaires de validation côté frontend
 */

/**
 * Valide le format d'une adresse email
 * @param email L'adresse email à valider
 * @returns true si l'email est valide, false sinon
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Normalise une adresse email (convertit en minuscules et supprime les espaces)
 * @param email L'adresse email à normaliser
 * @returns L'adresse email normalisée
 */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}